import { render } from "./CategoriserSetParameters.vue?vue&type=template&id=fccc9f7e"
import script from "./CategoriserSetParameters.vue?vue&type=script&lang=js"
export * from "./CategoriserSetParameters.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__